import MyDetails from 'components/account/MyDetails'
import PrivacyAndConsents from 'components/account/PrivacyAndConsents'
import SignInDetails from 'components/account/SignInDetails'

export enum MyAccountSections {
  MY_DETAILS = 'my-details',
  SIGN_IN_DETAILS = 'sign-in-details',
  PRIVACY_AND_CONSENTS = 'privacy-and-consents',
}

export const SECTION_COMPONENTS = {
  [MyAccountSections.MY_DETAILS]: {
    component: MyDetails,
    id: 0,
  },
  [MyAccountSections.PRIVACY_AND_CONSENTS]: {
    component: PrivacyAndConsents,
    id: 1,
  },
  [MyAccountSections.SIGN_IN_DETAILS]: {
    component: SignInDetails,
    id: 2,
  },
}
